import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MessageComponent>,
    private router: Router) { }


  home() {
    this.router.navigate(['home']);
    this.dialogRef.close();
  }

  create() {
    this.router.navigate(['create/create-module-config']);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  view() {
    this.router.navigate(['view/view-all-screen-configs']);
    this.dialogRef.close();
  }

  configureBenefits() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false)
  }
}

